import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function FAQ() {
  const {
    language
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const content = {
    en: {
      title: 'Frequently asked questions',
      faqs: [{
        q: 'Do you offer airport transfers in Ibiza?',
        a: 'Yes. We provide private airport pickup and drop-off across the island.'
      }, {
        q: 'Can I book by WhatsApp?',
        a: 'Yes. The fastest and easiest way to book is by WhatsApp.'
      }, {
        q: 'Is the price fixed?',
        a: 'Yes. The price we quote is the price you pay. No hidden fees, no surge pricing, no surprises at the end of the journey.'
      }, {
        q: 'Do you track delayed flights?',
        a: 'Yes. We monitor flight arrivals in real time. If your flight is delayed, your driver adjusts the pickup time automatically.'
      }, {
        q: 'Can you arrange transport for groups?',
        a: 'Yes. We offer transport for couples, families and groups.'
      }, {
        q: 'Do you offer hotel and villa transfers?',
        a: 'Yes. We provide transport to hotels, villas, marinas, restaurants and beach clubs.'
      }, {
        q: 'How much is an airport transfer in Ibiza?',
        a: 'Airport transfer prices in Ibiza depend on the destination and vehicle type. Standard transfers start from around 100€–140€ for popular routes. We always confirm the exact fixed price before the journey.'
      }]
    },
    es: {
      title: 'Preguntas frecuentes',
      faqs: [{
        q: '¿Ofrecéis traslados al aeropuerto en Ibiza?',
        a: 'Sí. Ofrecemos recogida y traslado privado en el aeropuerto por toda la isla.'
      }, {
        q: '¿Puedo reservar por WhatsApp?',
        a: 'Sí. La forma más rápida y sencilla de reservar es por WhatsApp.'
      }, {
        q: '¿El precio es fijo?',
        a: 'Sí. El precio que te damos es el precio que pagas. Sin cargos ocultos, sin precios dinámicos, sin sorpresas al final del trayecto.'
      }, {
        q: '¿Hacéis seguimiento de vuelos retrasados?',
        a: 'Sí. Monitorizamos las llegadas de vuelos en tiempo real. Si tu vuelo se retrasa, tu conductor ajusta la hora de recogida automáticamente.'
      }, {
        q: '¿Podéis organizar transporte para grupos?',
        a: 'Sí. Ofrecemos transporte para parejas, familias y grupos.'
      }, {
        q: '¿Ofrecéis traslados a hoteles y villas?',
        a: 'Sí. Ofrecemos transporte a hoteles, villas, marinas, restaurantes y beach clubs.'
      }, {
        q: '¿Cuánto cuesta un traslado desde el aeropuerto de Ibiza?',
        a: 'Los precios de traslados desde el aeropuerto de Ibiza dependen del destino y tipo de vehículo. Los traslados estándar empiezan desde unos 100€–140€ para rutas populares. Siempre confirmamos el precio fijo exacto antes del trayecto.'
      }]
    }
  };
  const text = content[language];
  return <section id="faq" className="py-14 md:py-28 bg-warm-white" data-id="element-22">
      <div className="mx-auto max-w-3xl px-5" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12 md:mb-16" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-heading text-navy mb-4" data-id="element-25">
            {text.title}
          </h2>
          <div className="w-12 h-px bg-gold-subtle/40 mx-auto" data-id="element-26" />
        </motion.div>

        <div className="space-y-3" data-id="element-27">
          {text.faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white rounded-xl border border-stone/10 overflow-hidden" data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left" aria-expanded={openIndex === index} data-id="element-29">
                <span className="text-navy font-medium pr-4" data-id="element-30">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-stone shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>
              <AnimatePresence data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-33">
                    <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-34">
                      <p className="text-slate leading-relaxed" data-id="element-35">{faq.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}